import { useState } from "react";
import Api from "../../../shared/api/api";

export default function LockedAdminAssessments({
  lockedAssessments = [],
  setLockedAssessments,
}) {
  const [unlockingKey, setUnlockingKey] = useState("");
  const [error, setError] = useState("");

  const unlockAssessment = async (
    userId,
    testId
  ) => {
    const assessmentKey = `${userId}-${testId}`;

    setUnlockingKey(assessmentKey);
    setError("");

    try {
      const response = await Api.unlockAssessment(
        userId,
        testId
      );

      if (response?.error) {
        throw new Error(response.error);
      }

      if (
        typeof setLockedAssessments === "function"
      ) {
        setLockedAssessments(
          (currentAssessments) =>
            currentAssessments.filter(
              (assessment) =>
                !(
                  assessment.user_id === userId &&
                  assessment.test_id === testId
                )
            )
        );
      }
    } catch (requestError) {
      console.error(
        "Unable to unlock FourH assessment:",
        requestError
      );

      setError(
        requestError?.message ||
          "The assessment could not be unlocked."
      );
    } finally {
      setUnlockingKey("");
    }
  };

  return (
    <section className="lockedAssessmentListDiv">
      <h1 className="adminHeaders">
        Locked User Assessments
      </h1>

      {error && (
        <p className="fourHFormStatus error" role="alert">
          {error}
        </p>
      )}

      {lockedAssessments.length === 0 ? (
        <p className="fourHEmptyMessage">
          There are no locked assessments.
        </p>
      ) : (
        <div className="listOfLockedAssessments fourHTableWrapper">
          <table className="fourHAdminTable">
            <thead>
              <tr>
                <th scope="col">User ID</th>
                <th scope="col">Test ID</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>

            <tbody>
              {lockedAssessments.map(
                (assessment) => {
                  const assessmentKey = `${assessment.user_id}-${assessment.test_id}`;

                  const isUnlocking =
                    unlockingKey === assessmentKey;

                  return (
                    <tr key={assessmentKey}>
                      <td data-label="User ID">
                        {assessment.user_id}
                      </td>

                      <td data-label="Test ID">
                        {assessment.test_id}
                      </td>

                      <td data-label="Actions">
                        <button
                          type="button"
                          className="unlockAssessmentBtn"
                          onClick={() =>
                            unlockAssessment(
                              assessment.user_id,
                              assessment.test_id
                            )
                          }
                          disabled={isUnlocking}
                        >
                          {isUnlocking
                            ? "Unlocking..."
                            : "Unlock Assessment"}
                        </button>
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}